import Immutable from 'immutable';
import { createSelector } from 'reselect';

const getRecommendationsData = state => state.getIn(['bibs', 'recommendations', 'items'], Immutable.List());

export const selectRecommendations = createSelector([getRecommendationsData], data => data);

export default { selectRecommendations };
